import { inject } from 'vue';
import { wait } from '@/plugins/vue-wait.ts';
import type { Wait } from '@/plugins/vue-wait.ts';

export const useWait = () => {
    // The plugin provides the same `wait` singleton it installs, so fall back to
    // it when there is no active component instance to inject from — e.g. when
    // called from a detached async context such as a click handler that ran
    // after setup. Vue skips the inject default outside setup and returns
    // undefined, so coalesce explicitly. Both paths resolve to one shared state.
    const $wait = inject<Wait>('$wait', wait) ?? wait;
    return {
        is: (loader: string | string[]): boolean => $wait.is(loader),
        any: (): boolean => $wait.any(),
        start: (name: string): void => $wait.start(name),
        end: (name: string): void => $wait.end(name),
        waiting: (): string[] => $wait.waiting(),
    };
};
